import React, { useEffect } from 'react';
import { LinkCardCustom } from '../../../components/Cards/LinkCard';
import Accordion from '../../../components/Accordion';
import { PageContainer } from '../../../styles/styles';
import * as S from './styles';
import { useBeneficiarioEventual } from '../../../contexts/BeneficiarioEventual/context';

function Guias() {
    const { clearBeneficiarioEventual } = useBeneficiarioEventual();

    const LINK_TO_CONSULT = '/dados_beneficiario/selecionar_beneficiario_guia';
    const LINK_TO_INCLUDE = '/dados_beneficiario/selecionar_solicitacao_guias';

    useEffect(() => {
        clearBeneficiarioEventual();
    }, []);

    return (
        <PageContainer>
            <Accordion title="Escolha a ação você deseja" hasCollapse={false}>
                <S.ContainerCards>
                    <LinkCardCustom
                        link={LINK_TO_INCLUDE}
                        title="Solicitar nova guia"
                        desc="Pessoa contratada pela empresa solicite uma nova guia."
                        icons={{ left: { name: 'person' } }}
                    />

                    <LinkCardCustom
                        link={LINK_TO_CONSULT}
                        title="Consultar guia"
                        desc="Pessoa contratada pela empresa. Visualize a guia aqui."
                        icons={{ left: { name: 'group' } }}
                    />
                </S.ContainerCards>
            </Accordion>
        </PageContainer>
    );
}

export default Guias;
